import React, { useState, useEffect, useRef } from 'react';
import { Modal, message, Empty, Card, Typography, Collapse, Divider, Row, Col, Spin, Popover, Pagination, Skeleton, Drawer, Space } from 'antd';
import moment from 'moment';
import 'moment-timezone';
import { InfoCircleOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';
import { Link } from "react-router-dom";
import { useSelector } from 'react-redux';
import FeatherIcon from 'feather-icons-react';
import MailDetailView from '../Email/MailDetailView';
import { FetchRelatedEmails, FetchRelatedEmails1, executeEmailSummary, FetchDetailspage, findOneByMailService, removeMailFromAstraDB, findEmailSummaryByEntity, deleteEmailActivity } from '../../../Api/Services/EmailApiSevices'
import { FetchAllLead, FetchAllLeadByDep } from '../../../Api/Services/LeadApiServices'
import { FetchAllContact, FetchAllContactByDep } from '../../../Api/Services/ContactApiService'
import { FetchAllAttendeeList } from '../../../Api/Services/CommonApiService' // getMailInfo
import { PaperPlaneSendIcon, PaperPlaneReciveIcon, CancelIcon, AiDbIcon } from '../../../components/Icons/Icons';
import { Button } from '../../../components/buttons/buttons';
import CustomHtmlParser from '../Email/CustomHtmlParser'

const { Text } = Typography;
const { Panel } = Collapse;
const EmailTable = ({ UrlId, NacTrigger, refreshTrigger, tabKey, setNaCTrigger, profile, emailactiontype }) => {
    const PAGE_SIZE = 20;
    const loadingRef = useRef(false);
    const isClickingRef = useRef(false);
    const skipOnChangeRef = useRef(false);
    const localData = useSelector((state) => state.localRedux);
    const companyProfile = localData.company
    const urlPathname = window.location.pathname;
    const urlSearch = window.location.search;
    const VectorDb = localData.vectorDb
    const combinedUrl = urlPathname + urlSearch;
    const [allMails, setAllMails] = useState()
    const [emailPopup, setEmailPopup] = useState(false)
    const [emailUnlink, setEmailUnlink] = useState(false)
    const [popupType, setPopupType] = useState()
    const [emailOpenId, setEmailOpenId] = useState()
    const [allattendeeData, setAllattendeeData] = useState()
    const [emailActivityId, setEmailActivityId] = useState()
    const [openPage, setOpenPage] = useState(Array(allMails?.length).fill(false));
    const [panelData, setPanelData] = useState();
    const [openPanels, setOpenPanels] = useState([]);
    const [allLeadList, setAllLeadList] = useState();
    const [allContactList, setAllContactList] = useState();
    const [symmaruData, setSymmaruData] = useState()
    const [loadingPage, setLoadingPage] = useState(true);
    const [loadingPage1, setLoadingPage1] = useState(false);
    const [apiPage, setApiPage] = useState();
    const [activeKey, setActiveKey] = useState()
    const [tablePage, setTablePage] = useState();
    const [totalCount, setTotalCount] = useState([])
    const [apiType, setApiType] = useState()
    const [doubleClick, setDoubleClick] = useState(false)
    const mergeUniqueById = (existing = [], incoming = [], idKey = 'mailServiceId') => {
        const seen = new Set(existing.map(item => item[idKey]));
        return [...existing, ...incoming.filter(item => !seen.has(item[idKey]))];
    };
    function extractTimeZoneName(tzString) {
        const parts = tzString.split(" ");
        return parts[1];
    }
    function normalizeEmailData(input) {
        const BodywithLinks = (data) => {
            const urlPattern = /(https?:\/\/[^\s]+)/g;
            const formattedMessage = data.replace(urlPattern, (url) => {
                const escapedUrl = encodeURIComponent(url);
                return `<a href="${escapedUrl}" target="_blank">${url}</a>`;
            });
            return formattedMessage.replace(/\n/g, '<br />');
        };
        let bodyText = "";
        if (emailactiontype?.emailType === "Outlook") {
            bodyText = input ? input?.bodyContent ? input.bodyContent : "" : ""
        }
        else if (emailactiontype?.emailType === "Google" || emailactiontype?.emailType === "Zoho" || emailactiontype?.emailType === "Other Email") {
            bodyText = input ? (input?.htmlContent && input?.htmlContent !== "") ? input.htmlContent : input?.textContent ? BodywithLinks(input.textContent) : "" : ""
        }
        return {
            body: bodyText,
        };
    }
    function normalizeEmailDataforOutlook(input) {
        let bodyText = "";
        if (emailactiontype?.emailType === "Outlook") {
            bodyText = input ? input?.bodyContent ? input.bodyContent : "" : ""
        }
        return {
            body: bodyText,
        };
    }
    const handleCollapseChange = async (keys) => {
        const newOpenPanels = keys.map(Number);
        const added = newOpenPanels.find((key) => !openPanels.includes(key));
        if (added !== undefined) {
            if (!panelData[added]?.body) {
                const mailid = allMails[added]
                if (profile?.userId === mailid.linkedBy || emailactiontype?.email?.toLowerCase() === mailid.serverEmail?.toLowerCase()) {
                    if (mailid.mailServer === emailactiontype?.emailType) {
                        try {
                            const Response = await FetchDetailspage(mailid.sourceId, mailid.actionType === "Recived" ? "INBOX" : mailid.actionType === "Sent" ? "Sent" : "")
                            let modifiedData;
                            const originalData = Response.data;
                            if (emailactiontype?.emailType === 'Outlook') {
                                modifiedData = normalizeEmailDataforOutlook(originalData)
                            } else if (emailactiontype?.emailType === 'Google' || emailactiontype?.emailType === 'Zoho' || emailactiontype?.emailType === "Other Email") {
                                modifiedData = normalizeEmailData(originalData);
                            };
                            const updatedPanelData = [...panelData];
                            updatedPanelData[added] = { ...updatedPanelData[added], body: modifiedData.body };
                            setPanelData(updatedPanelData);
                        }
                        catch (error) {
                            message.error(error)
                        }
                    }
                    else {
                        message.info("Unable to retrieve the selected email. Please check your email settings or contact the administrator for support")
                    }
                }
                else {
                    message.info("Email details not found. Please contact your admin for details")
                }
            }
        }
        setOpenPanels(newOpenPanels);
    };
    const handleOpenPageChange = (index) => {
        const newPopoverOpenStates = [...openPage];
        newPopoverOpenStates[index] = !newPopoverOpenStates[index];
        setOpenPage(newPopoverOpenStates);
    };
    const emailClose = () => {
        setEmailPopup(false)
        setPopupType()
        setEmailOpenId()
        setNaCTrigger("CallBack")
    }
    const emailCloseUnlink = () => {
        setEmailUnlink(false)
        setEmailActivityId()
    }
    const ViewDetailPage = (id, type, userId, server, mailid) => {
        if (profile?.userId === userId || emailactiontype?.email?.toLowerCase() === mailid.serverEmail?.toLowerCase()) {
            if (server === emailactiontype?.emailType) {
                setEmailPopup(true)
                setPopupType(type)
                setEmailOpenId(id)
                setNaCTrigger("trigger")
            }
            else {
                message.info("Unable to retrieve the selected email. Please check your email settings or contact the administrator for support")
            }
        }
        else {
            message.info("Email details not found. Please contact your admin for details")
        }
    }
    async function CreatorLedadListApi() {
        try {
            let Lead;
            if (profile.department === "Customer Care" || profile.department === "Marketing") {
                Lead = await FetchAllLeadByDep()
            }
            else {
                Lead = await FetchAllLead()
            }
            setAllLeadList(Lead?.items)
        }
        catch (error) {
            message.error(error)
        }
    }
    async function CreatorcontactListApi() {
        try {
            let contact;
            if (profile.department === "Customer Care" || profile.department === "Marketing") {
                contact = await FetchAllContactByDep()
            }
            else {
                contact = await FetchAllContact()
            }
            setAllContactList(contact?.items)
        }
        catch (error) {
            message.error(error)
        }
    }
    // async function getOrganizerFrom(id, type, dataList, address) {
    //     try {
    //         const response = await getMailInfo(
    //             companyProfile?.companyId,
    //             address
    //         );
    //         if (response?.firstName) {
    //             return {
    //                 name: `${response?.firstName || ''} ${response?.lastName || ''}`.trim(),
    //                 email: type === "Leads"
    //                     ? response?.primaryEmail
    //                     : response?.email
    //             };
    //         }
    //         return {
    //             name: "Not Available",
    //             email: "Not Available"
    //         };
    //     } catch {
    //         return {
    //             name: "Not Available",
    //             email: "Not Available"
    //         };
    //     }
    // }
    function getOrganizerFrom(id, type, dataList) { // address
        const filtered = dataList.filter(item => item.type === type);
        return filtered.find(item => item.id === id) ||
            { name: "Not Available", email: "Not Available" };
    }
    // const getPerosnnDetails = (fromEmail, dataList,linkedBy) => {
    //     const user = dataList.find(u => {
    //         if (u.type === "User") {
    //             return (
    //                 u.emailConfigurationMail?.toLowerCase() === fromEmail?.toLowerCase() ||
    //                 u.email?.toLowerCase() === fromEmail?.toLowerCase()
    //             );
    //         }
    //         return u.email?.toLowerCase() === fromEmail?.toLowerCase();
    //     });
    //     const name = user?.name?.trim();
    //     const validData = name || fromEmail;
    //     return validData
    // };
    function getOrganizerFromEmail(email, type, dataList) {
        const filtered = dataList.filter(item => item.type === type);
        const user = filtered.find(u => u.emailConfigurationMail?.toLowerCase() === email?.toLowerCase() || u.email?.toLowerCase() === email?.toLowerCase());
        return user || { name: "Not Available", email: "Not Available" }
    }
    const getattendeeFrom = (type, fromEmail, dataList, linkedBy) => {
        const users = dataList.filter(item => item.type === type);
        let user = null;

        if (type === "User" && linkedBy) {
            user = users.find(u =>
                u.id === linkedBy &&
                u.emailConfigurationMail?.toLowerCase() === fromEmail?.toLowerCase()
            );
            if (!user) {
                user = users.find(u => u.id === linkedBy);
            }
        }
        // const user = users.find(u => {
        //     if (u.type === "User") {
        //         if (linkedBy && u.id === linkedBy) {
        //             return (
        //                 u.emailConfigurationMail?.toLowerCase() === fromEmail?.toLowerCase() ||
        //                 u.email?.toLowerCase() === fromEmail?.toLowerCase()
        //             );
        //         }
        //         return (
        //             u.emailConfigurationMail?.toLowerCase() === fromEmail?.toLowerCase() ||
        //             u.email?.toLowerCase() === fromEmail?.toLowerCase()
        //         );
        //     }
        //     return u.email?.toLowerCase() === fromEmail?.toLowerCase();
        // });
        const name = user?.name?.trim();
        const validData = name || fromEmail;
        return validData
    };
    function formatAttendees(attendeeList, hostEmail, configEmail, apiAttendeesList, linkby) {
        if (!Array.isArray(attendeeList)) return null;
        const attendeeData = [];
        const includedEmails = new Set();
        const filteredAttendees = attendeeList.filter(att => att.address?.toLowerCase() !== hostEmail?.toLowerCase() && att.email?.toLowerCase() !== hostEmail?.toLowerCase());
        filteredAttendees.forEach(att => {
            const email = att.address || att.email;
            if (!email) return;
            const apiMatch = apiAttendeesList.find(
                u => {
                    if (u.type === "User") {
                        if (linkby && u.id === linkby) {
                            return (
                                u.emailConfigurationMail?.toLowerCase() === email?.toLowerCase() ||
                                u.email?.toLowerCase() === email?.toLowerCase()
                            );
                        }
                        return (
                            u.emailConfigurationMail?.toLowerCase() === email?.toLowerCase() ||
                            u.email?.toLowerCase() === email?.toLowerCase()
                        );
                    }
                    return u.email?.toLowerCase() === email?.toLowerCase();
                });

            if (apiMatch && !includedEmails.has(email?.toLowerCase())) {
                attendeeData.push(apiMatch);
                includedEmails.add(email?.toLowerCase());
            }
        });
        if (configEmail && configEmail?.toLowerCase() !== hostEmail?.toLowerCase() && !includedEmails.has(configEmail?.toLowerCase()) && linkby === profile?.userId) {
            attendeeData.push({
                id: profile?.userId || null,
                name: `${profile?.firstName || ''} ${profile?.lastName || ''}`.trim() || configEmail?.toLowerCase(),
                email: configEmail?.toLowerCase(),
                type: 'Users'
            });
        }
        return attendeeData;
    }
    function findDataByEmail(email, leadData = [], contactData = []) {
        const leadMatchfound = leadData.find(item => item.primary_email?.toLowerCase() === email?.toLowerCase());
        if (leadMatchfound) {
            return {
                name: `${leadMatchfound?.first_name} ${leadMatchfound?.last_name}`,
                email: leadMatchfound?.primary_email?.toLowerCase(),
            };
        }
        const contactMatchfound = contactData.find(item => item.email?.toLowerCase() === email?.toLowerCase());
        if (contactMatchfound) {
            return {
                name: `${contactMatchfound?.first_name} ${contactMatchfound?.last_name}`,
                email: contactMatchfound?.email?.toLowerCase(),
            };
        }
        return {
            name: "Not Available",
            email: "Not Available"
        };
    }
    async function mailServerEmailData(mailServiceId) {
        const cleanString = (str) => str.trim().replace(/^["']|["']$/g, "");
        const parseEmail = (emailString) => {
            emailString = cleanString(emailString);
            const match = emailString.match(/(.*)<(.+)>/);
            if (match) {
                return {
                    name: cleanString(match[1]),
                    address: match[2].trim(),
                };
            }
            return {
                name: "",
                address: emailString,
            };
        };
        const normalizeField = (field) => {
            if (!field) return [];
            return field.split(",").map((item) => parseEmail(item.trim()));
            // return field.split(/[;,]/).map((item) => parseEmail(item.trim()));
        };
        if (mailServiceId) {
            try {
                const MailServerResponse = await findOneByMailService(mailServiceId)
                const formattedFrom = parseEmail(MailServerResponse?.from || "");
                const formattedTo = normalizeField(MailServerResponse?.to || "");
                return {
                    fromData: formattedFrom,
                    toData: formattedTo,
                };
            } catch (error) {
                const formattedFrom = parseEmail("");
                const formattedTo = normalizeField("");
                return {
                    fromData: formattedFrom,
                    toData: formattedTo,
                };
            }
        } else {
            const formattedFrom = parseEmail("");
            const formattedTo = normalizeField("");
            return {
                fromData: formattedFrom,
                toData: formattedTo,
            };
        }
    }
    async function RecentActivity2() {
        try {
            const data = await FetchRelatedEmails1(UrlId[1], apiType);
            setTotalCount(data)
        } catch (error) {
            message.error(error);
        }
    }
    async function GetMailSummary() {
        try {
            setLoadingPage1(true);
            const data = await findEmailSummaryByEntity(UrlId[1], apiType);
            setSymmaruData(data.data)
            setLoadingPage1(false);
        } catch (error) {
            setLoadingPage1(false);
            message.error(error);
        }
    }
    async function executeEmailSummaryupdate() {
        try {
            setLoadingPage1(true);
            await executeEmailSummary(UrlId[1], apiType, {});
            GetMailSummary()
            setLoadingPage1(false);
        } catch (error) {
            setLoadingPage1(false);
            message.error(error);
        }
    }
    async function AllEmails(page) {
        try {
            setLoadingPage(true);
            const data = await FetchRelatedEmails(UrlId[1], apiType, page, PAGE_SIZE);
            const AllData = data?.filter(item => item.sourceType === "Mail")
            const FormatedData = await Promise.all(AllData?.map(async (email) => {
                const { entityId, entityType, actionType, mailServiceId } = email;
                const { fromData, toData } = await mailServerEmailData(mailServiceId)
                let FromData;
                if (actionType === "Sent") {
                    FromData =
                        // (emailactiontype?.email?.toLowerCase() === fromData?.address?.toLowerCase()) ?
                        //     `${profile?.firstName} ${profile?.lastName}` : 
                        getattendeeFrom("User", fromData?.address, allattendeeData, email.linkedBy)
                }
                if (actionType === "Recived") {
                    if (entityType === "Lead" || entityType === "Contact") {
                        const origanizerdata = getOrganizerFrom(entityId, `${entityType}s`, allattendeeData, fromData?.address)
                        FromData = origanizerdata?.name || origanizerdata?.email
                    }
                    else if (entityType === "Case") {
                        const origanizerdata = findDataByEmail(fromData?.address, allLeadList, allContactList)
                        FromData = origanizerdata?.name || origanizerdata?.email
                    }
                    else {
                        const origanizerdata = getOrganizerFromEmail(fromData?.address, "Contacts", allattendeeData)
                        FromData = origanizerdata?.name || origanizerdata?.email
                    }
                }
                const ToData = formatAttendees(toData, fromData?.address, emailactiontype?.email, allattendeeData, email.linkedBy);
                return {
                    ...email,
                    FromData,
                    ToData,
                }
            }));
            if (page === 1) {
                setAllMails(FormatedData);
                setPanelData(FormatedData.map(() => ({ body: null })));
            } else {
                setAllMails((prev) => {
                    const merged = mergeUniqueById(prev, FormatedData);
                    setPanelData((prevPanel) => [
                        ...prevPanel,
                        ...FormatedData.map(() => ({ body: null }))
                    ]);
                    return merged;
                });
            }
            setLoadingPage(false);
            if (!loadingPage1 && FormatedData.length > 0) {
                GetMailSummary()
            }
        } catch (error) {
            setLoadingPage(false);
            message.error(error);
        }
    }
    const handleCollapseChange1 = async (keys) => {
        setActiveKey(keys)
    };
    const formatDateTimeData = (CreateDate) => {
        const createdTime = new Date(CreateDate);
        const tzString = profile?.timeZone || "(GMT+0:00) UTC";
        const tz = extractTimeZoneName(tzString);
        const currentrealTime = moment().tz(tz).format("YYYY-MM-DD HH:mm")
        const currentTime = new Date(currentrealTime)
        const timeDifference = Math.floor((currentTime - createdTime) / (1000 * 60));
        const days = Math.floor(timeDifference / 1440);
        const formattedDate = createdTime.toLocaleDateString("en-US", {
            month: "short",
            day: "2-digit",
            year: "numeric"
        });
        return days < 1 ? "Today" : formattedDate;
    };
    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const formattedDate = date.toLocaleString('en-US', {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
            hour: 'numeric',
            minute: 'numeric',
            second: 'numeric',
            hour12: false,
        });
        const timezoneCorrectedDate = new Date(formattedDate);
        const year = timezoneCorrectedDate.getFullYear();
        const month = String(timezoneCorrectedDate.getMonth() + 1).padStart(2, '0');
        const day = String(timezoneCorrectedDate.getDate()).padStart(2, '0');
        const hours = String(timezoneCorrectedDate.getHours()).padStart(2, '0');
        const minutes = String(timezoneCorrectedDate.getMinutes()).padStart(2, '0');
        const formattedCustom = `${year}-${month}-${day} ${hours}:${minutes}`;
        return formattedCustom;
    };
    const convertTime = (timeStr, timeFormat) => {
        let hours;
        let minutes;
        // let seconds;
        let period;
        if (timeStr.toLowerCase().includes('am') || timeStr.toLowerCase().includes('pm')) {
            // Parse 12-hour time string
            const timeParts = timeStr.match(/(\d{1,2}):(\d{2}):?(\d{2})?/);
            hours = parseInt(timeParts[1], 10);
            minutes = parseInt(timeParts[2], 10);
            // seconds = parseInt(timeParts[3], 10);
            period = timeStr.match(/(am|pm)/i)[0].toLowerCase();

            if (period === 'pm' && hours !== 12) {
                hours += 12;
            } else if (period === 'am' && hours === 12) {
                hours = 0;
            }
        } else {
            // Parse 24-hour time string
            const timeParts = timeStr.split(':');
            hours = parseInt(timeParts[0], 10);
            minutes = parseInt(timeParts[1], 10);
            // seconds = parseInt(timeParts[2], 10);
        }
        if (timeFormat === '12hrs' || timeFormat === '12-hour') {
            period = hours >= 12 ? 'PM' : 'AM';
            hours = hours % 12 || 12;
            // return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')} ${period}`;
            return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')} ${period}`;
        }
        // No need for an else here because we return in the if above
        if (timeFormat === '24hrs' || timeFormat === '24-hour') {
            // return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
            return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
        }
        throw new Error('Invalid time format specified');
    };
    const timeadnDate = (dateTime) => {
        const [date, time] = dateTime.split(" ");
        // const formattedDate = profile?.dateFormate ? moment(date).format(profile.dateFormate) : moment(date).format("YYYY-MM-DD");
        const formattedDate = date;
        const formattedTime = convertTime(moment(time, "HH:mm:ss").format("HH:mm:ss"), profile.timeFormat ? profile.timeFormat : "24hrs");
        return { date: formattedDate, time: formattedTime };
    }
    function convertAndFormatDateTime(dateTime, company, profile) {
        if (!dateTime || !company?.timeZone || !profile?.timeZone) return "";
        const extractTimezoneName = (tzStr) => {
            const match = tzStr.match(/\)\s*([A-Za-z/_]+)/);
            return match ? match[1] : "";
        };
        const fromTimezone = extractTimezoneName(company?.timeZone);
        const toTimezone = extractTimezoneName(profile?.timeZone);
        if (!moment.tz.zone(fromTimezone) || !moment.tz.zone(toTimezone)) {
            console.warn("Invalid timezone provided");
            return "";
        }
        const converted = moment.tz(dateTime, fromTimezone).tz(toTimezone)
        const dateFormat = "YYYY-MM-DD";
        const timeFormat = "24hrs";
        const formattedDate = converted.format(dateFormat);
        const rawTime = converted.format("HH:mm");
        const formattedTime = convertTime(rawTime, timeFormat);

        return `${formattedDate} ${formattedTime}`
    }
    function convertAndFormatDateTime2(dateTime, company, profile) {
        if (!dateTime || !company?.timeZone || !profile?.timeZone) return "";

        const extractTimezoneName = (tzStr) => {
            const match = tzStr.match(/\)\s*([A-Za-z/_]+)/);
            return match ? match[1] : "";
        };

        const fromTimezone = extractTimezoneName(company?.timeZone);
        const toTimezone = extractTimezoneName(profile?.timeZone);

        if (!moment.tz.zone(fromTimezone) || !moment.tz.zone(toTimezone)) {
            console.warn("Invalid timezone provided");
            return "";
        }

        const converted = moment.tz(dateTime, fromTimezone).tz(toTimezone);

        // Get raw and formatted time
        const timeFormat = profile?.timeFormat && profile?.timeFormat !== "" ? profile.timeFormat : "24hrs";
        const rawTime = converted.format("HH:mm");
        const formattedTime = convertTime(rawTime, timeFormat);

        // Check if the date is today in the same target timezone
        const today = moment.tz(toTimezone).startOf('day');
        const isToday = converted.isSame(today, 'day');

        if (isToday) {
            return `Today, ${formattedTime}`;
        }
        const formattedDate = converted.format("MMM DD, YYYY");
        return `${formattedDate}, ${formattedTime}`;
    }
    async function UserDetailsApi() {
        try {
            const data = await FetchAllAttendeeList()
            setAllattendeeData(data)
        }
        catch (error) {
            setAllattendeeData([])
            message.error(error)
        }
    }
    const fetchAll = async () => {
        await Promise.allSettled([
            UserDetailsApi(),
            CreatorLedadListApi(),
            CreatorcontactListApi(),
        ])
    };
    const reFetchData = async () => {
        await Promise.allSettled([
            setApiPage(1),
            setTablePage(1),
            AllEmails(1),
            RecentActivity2()
        ])
    }
    useEffect(() => {
        if (UrlId !== undefined && UrlId !== null && UrlId[0] === "?LEAD") {
            setApiType("Lead")
        }
        else if (UrlId !== undefined && UrlId !== null && UrlId[0] === "?DEAL") {
            setApiType("Deal")
        }
        else if (UrlId !== undefined && UrlId !== null && UrlId[0] === "?CONTACT") {
            setApiType("Contact")
        }
        else if (UrlId !== undefined && UrlId !== null && UrlId[0] === "?ACCOUNT") {
            setApiType("Account")
        }
        else if (UrlId !== undefined && UrlId !== null && UrlId[0] === "?CASE") {
            setApiType("Case")
        }
        else if (UrlId !== undefined && UrlId !== null && UrlId[0] === "?FCASE") {
            setApiType("Case")
        }
        fetchAll()
    }, [])
    useEffect(() => {
        if (refreshTrigger === tabKey) {
            if (allattendeeData && allLeadList && allContactList) {
                if (NacTrigger !== "trigger") {
                    reFetchData()
                }
            }
        }
    }, [UrlId, apiType, NacTrigger, allattendeeData, allLeadList, allContactList, refreshTrigger, tabKey])
    const UnLinkApi = (id) => {
        setEmailUnlink(true)
        setEmailActivityId(id)
    }
    const GetCallback = async (id) => {
        try {
            const response = await deleteEmailActivity(id)
            if (response.status === 200) {
                setEmailActivityId()
                setEmailUnlink(false)
                message.success("Email unlinked")
                reFetchData()
            }
        }
        catch (error) {
            message.log(error)
        }
    }
    const [expandedItems, setExpandedItems] = useState({});
    const toggleExpand = (key) => {
        setExpandedItems(prev => ({
            ...prev,
            [key]: !prev[key]
        }));
    };
    const openRagIng = async (id, data) => {
        if (loadingRef.current) return;
        loadingRef.current = true;
        setDoubleClick(true)
        let hideMessage;
        try {
            hideMessage = message.loading("Loading...", 0);
            const payload = {};
            const response = await removeMailFromAstraDB(payload, id, data);
            if (response?.status === 200) {
                loadingRef.current = false;
                setDoubleClick(false)
                hideMessage();
                message.success("Updated Successfully!");
                reFetchData()
            }
        } catch (err) {
            loadingRef.current = false;
            setDoubleClick(false)
            hideMessage();
            message.error(err);
        }
    };
    const handleTableChange = async (page) => {
        if (skipOnChangeRef.current) {
            skipOnChangeRef.current = false;
            return;
        }
        const newTablePage = page;
        if (newTablePage === tablePage) {
            return;
        }
        setTablePage(newTablePage);
        const maxIndexNeeded = newTablePage * PAGE_SIZE;
        if (allMails.length < maxIndexNeeded) {
            skipOnChangeRef.current = false;
            const nextApiPage = apiPage + 1;
            AllEmails(nextApiPage);
            setApiPage(nextApiPage);
        }
        else {
            setApiPage(newTablePage);
        }
    };
    const handleTableChange2 = async (pagination, navigationType) => {
        skipOnChangeRef.current = true;
        if (isClickingRef.current) return;
        setTablePage(pagination);
        const maxIndexNeeded = pagination * PAGE_SIZE;
        if (allMails.length < maxIndexNeeded) {
            isClickingRef.current = true;
            const nextApiPage = apiPage + 1;
            AllEmails(nextApiPage);
            setApiPage(nextApiPage);
        }
        else {
            const nextApiPage = navigationType === "prev" ? apiPage - 1 : apiPage + 1
            setApiPage(nextApiPage);
        }
        skipOnChangeRef.current = false;
    };
    const sortedActivities = allMails
        ?.sort((a, b) => {
            const dateA = a.actionDate ? moment(convertAndFormatDateTime(a.actionDate, companyProfile, profile), "YYYY-MM-DD HH:mm") : null;
            const dateB = b.actionDate ? moment(convertAndFormatDateTime(b.actionDate, companyProfile, profile), "YYYY-MM-DD HH:mm") : null;
            if (!dateA || !dateB) return 0;
            return dateB - dateA;
        });
    const paginatedActivities = sortedActivities?.slice(
        (tablePage - 1) * PAGE_SIZE,
        tablePage * PAGE_SIZE) || [];
    useEffect(() => {
        if (isClickingRef.current && allMails) {
            isClickingRef.current = false;
        }
    }, [allMails]);
    return (
        <>
            {loadingPage ?
                <div className="spin">
                    <Spin />
                </div>
                :
                <>
                    {paginatedActivities?.length > 0 ?
                        <>
                            {apiType !== "Case" ? <div style={{ marginBottom: 15 }}>
                                <Card className="DetailsTabCard">
                                    <Collapse bordered={false} className="DetailsTabCollapse" activeKey={activeKey?.[0]} onChange={handleCollapseChange1}>
                                        <Panel
                                            header={<div style={{ display: "flex", alignItems: "center", minWidth: 0, width: "100%", flex: "1 1 0%" }}>
                                                <Text strong style={{
                                                    marginRight: 5,
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis",
                                                    whiteSpace: "nowrap",
                                                    minWidth: 0,
                                                    flex: "0 1 auto",
                                                }} title="Recent Emails Summary">Recent Emails Summary  <FeatherIcon className={`refresh-icon ${loadingPage1 ? "disabled" : ""}`} icon="refresh-cw" size={16}
                                                    style={{
                                                        marginLeft: 5, cursor: loadingPage1 ? "not-allowed" : "pointer", marginBottom: "-3px"
                                                    }}
                                                    onClick={(e) => {
                                                        e.stopPropagation(); // Prevent collapse toggle
                                                        if (!loadingPage1) {
                                                            executeEmailSummaryupdate();
                                                        }
                                                    }} /></Text>

                                            </div>}
                                            extra={symmaruData?.summarizedAt ?
                                                <div style={{ display: "flex", alignItems: "center", gap: 10, flexShrink: 0, whiteSpace: "nowrap" }}>
                                                    <div style={{ display: "flex", alignItems: "center" }}>
                                                        Last Updated: {convertAndFormatDateTime2(symmaruData.summarizedAt, companyProfile, profile)}
                                                    </div>
                                                </div> : false
                                            }
                                        >
                                            <Divider style={{ margin: 0 }} />
                                            <div style={{ marginTop: 10 }}>
                                                {loadingPage1 ?
                                                    (<Skeleton title={false} active paragraph={{ rows: 7 }} />
                                                    ) : (
                                                        <Text type="secondary">
                                                            {symmaruData?.emailSummaryId && symmaruData?.emailSummaryId !== "" ?
                                                                <CustomHtmlParser html={symmaruData?.emailSummary} key={1} page="Previewss" /> : "No Body"}</Text>
                                                    )}
                                            </div>
                                        </Panel>
                                    </Collapse>
                                </Card>
                            </div> : <></>}
                            <div>
                                {paginatedActivities?.map((item, index) => {
                                    const convertsDate = item.actionDate ? convertAndFormatDateTime(item.actionDate, companyProfile, profile) : item.actionDate;
                                    const CorrectActionDate = formatDate(convertsDate)
                                    const action = convertsDate ? timeadnDate(CorrectActionDate) : { date: "", time: "" };
                                    const formattedTimeDifference = action.date && action.date !== "" ? formatDateTimeData(action.date) : ""
                                    // const emailPerson = (emailactiontype?.email?.toLowerCase() === item.fromEmail?.toLowerCase()) ?
                                    //     `${profile?.firstName} ${profile?.lastName}` :
                                    //     getPerosnnDetails(item.fromEmail, allattendeeData, item.linkedBy)
                                    return (
                                        <div key={index} style={{ marginBottom: 15 }}>
                                            <Card className="DetailsTabCard">
                                                <Collapse bordered={false} className="DetailsTabCollapse" activeKey={openPanels.map(String)} // Keep panels open
                                                    onChange={handleCollapseChange}>
                                                    <Panel
                                                        header={
                                                            <div style={{ display: "flex", alignItems: "center", minWidth: 0, width: "100%", flex: "1 1 0%", gap: 5 }}>
                                                                {item.actionType === "Sent" ? (
                                                                    <span style={{ flexShrink: 0, display: "flex" }}>
                                                                        <PaperPlaneSendIcon height={16} width={16} />
                                                                    </span>
                                                                ) : item.actionType === "Recived" ? (
                                                                    <span style={{ flexShrink: 0, display: "flex" }}>
                                                                        <PaperPlaneReciveIcon height={16} width={16} />
                                                                    </span>
                                                                ) : ""}
                                                                <Text strong style={{
                                                                    marginRight: 5,
                                                                    overflow: "hidden",
                                                                    textOverflow: "ellipsis",
                                                                    whiteSpace: "nowrap",
                                                                    minWidth: 0,
                                                                    flex: "0 1 auto",
                                                                }} title={item?.subject !== "" ? item.subject : "(No Subject)"}>
                                                                    {item?.subject ? item.subject : "(No Subject)"}</Text>
                                                                <span style={{ color: "#adb4d2", flexShrink: 0 }}>|</span>
                                                                <span style={{
                                                                    color: "#adb4d2",
                                                                    fontSize: 12,
                                                                    marginTop: "0.2rem",
                                                                    overflow: "hidden",
                                                                    textOverflow: "ellipsis",
                                                                    whiteSpace: "nowrap",
                                                                    minWidth: 0,
                                                                    flex: "0 1 auto",
                                                                }} title={item.FromData}>{item.FromData}</span>
                                                            </div>
                                                        }
                                                        key={String(index)}
                                                        extra={<div style={{ display: "flex", alignItems: "center", gap: 10, flexShrink: 0, whiteSpace: "nowrap" }}>
                                                            <div style={{ display: "flex", alignItems: "center" }}>
                                                                <FeatherIcon icon="clock" size={16} style={{ marginRight: 5 }} />{formattedTimeDifference}, {action.time}
                                                            </div>
                                                            <Popover
                                                                placement="bottom"
                                                                content={<>
                                                                    <div role="button" className="TableMore-Action" tabIndex="0" style={{ marginBottom: 5 }} onClick={(event) => event.stopPropagation()} onKeyDown={(event) => { if (event.key === "Enter" || event.key === " ") { event.stopPropagation(); } }}>
                                                                        <Link to={combinedUrl} className="text_icon" onClick={() => { ViewDetailPage(item.sourceId, item.actionType === "Recived" ? "INBOX" : item.actionType === "Sent" ? "Sent" : "", item.linkedBy, item.mailServer, item); handleOpenPageChange(index) }}>
                                                                            <FeatherIcon icon="eye" size={16} style={{ marginRight: 5 }} /> View Details
                                                                        </Link>
                                                                    </div>
                                                                    <div role="button" className="TableMore-Action" tabIndex="0" style={{
                                                                        pointerEvents: doubleClick ? "none" : "auto",
                                                                        opacity: doubleClick ? 0.5 : 1,
                                                                        marginBottom: (VectorDb?.isMail && profile.mailInjectionRequired === "Yes") ? 5 : 0
                                                                    }} onClick={(event) => event.stopPropagation()} onKeyDown={(event) => { if (event.key === "Enter" || event.key === " ") { event.stopPropagation(); } }}>
                                                                        <Link to={combinedUrl} className="text_icon" onClick={() => {
                                                                            if (doubleClick) return;
                                                                            UnLinkApi(item.emailActivityId); handleOpenPageChange(index)
                                                                        }}>
                                                                            <FeatherIcon icon="link-2" size={16} style={{ marginRight: 5 }} /> Unlink
                                                                        </Link>
                                                                    </div>
                                                                    {(VectorDb?.isMail && profile.mailInjectionRequired === "Yes") ?
                                                                        <div role="button" className="TableMore-Action" style={{
                                                                            pointerEvents: doubleClick ? "none" : "auto",
                                                                            opacity: doubleClick ? 0.5 : 1,
                                                                        }}
                                                                            tabIndex="0" onClick={(event) => event.stopPropagation()} onKeyDown={(event) => { if (event.key === "Enter" || event.key === " ") { event.stopPropagation(); } }}>
                                                                            <Link to={combinedUrl} className="text_icon" onClick={() => {
                                                                                if (doubleClick) return;
                                                                                openRagIng(item.emailActivityId, item.isBusinessMail === "Yes" ? "Yes" : "No"); handleOpenPageChange(index)
                                                                            }}>
                                                                                <AiDbIcon height='16' width='16' marginRight={5} /> {item.isBusinessMail === "Yes" ? "Remove from vector store" : "Add to vector store"}
                                                                            </Link>
                                                                        </div> : <></>}
                                                                </>
                                                                }
                                                                trigger="hover"
                                                                open={openPage[index]}
                                                                onOpenChange={() => handleOpenPageChange(index)}
                                                            >
                                                                <div role="button" style={{ display: "flex", alignItems: "center" }} tabIndex="0" onClick={(event) => event.stopPropagation()} onKeyDown={(event) => { if (event.key === "Enter" || event.key === " ") { event.stopPropagation(); } }}>
                                                                    <FeatherIcon icon="more-vertical" size={18} style={{ cursor: "pointer" }} />
                                                                </div>
                                                            </Popover>
                                                        </div>}
                                                    >
                                                        <Divider style={{ margin: 0 }} />
                                                        <div style={{ marginTop: 10 }}>
                                                            {panelData && panelData[index]?.body ? (
                                                                <Text type="secondary">
                                                                    {panelData[index].body && panelData[index].body !== "" ? <CustomHtmlParser html={panelData[index].body} key={index} page="Previewss" /> : "No Body"}</Text>
                                                            ) : (
                                                                <Skeleton title={false} active />
                                                            )}
                                                        </div>

                                                        <Row gutter={16} style={{
                                                            marginTop: 10,
                                                            borderRadius: 15,
                                                            border: "1px solid #dddddd"
                                                        }}>
                                                            <Col span={12} style={{ borderRight: "1px solid #dddddd", padding: "5px 10px" }}>
                                                                <Text type="secondary" className='RightSide-Lable'>From</Text>
                                                                <br />
                                                                <div className='div-ellipsis' title={item.FromData}>{item.FromData}</div>
                                                            </Col>
                                                            <Col span={12} style={{ padding: "5px 10px" }}>
                                                                <Text type="secondary" className='RightSide-Lable'>To  <InfoCircleOutlined title='The list below shows CRM users who were copied in the email. To view the full list of recipients, please click ‘View Details’' />
                                                                    {/* {item.actionType === "Recived" ? <InfoCircleOutlined style={{ fontSize: "small", color: '#0000009c', cursor: 'pointer', margin: "0px" }}
                                                    title={
                                                        UrlId !== undefined && UrlId !== null && UrlId[0] === "?CASE" ?
                                                            "The details below reflect only the case assignee at the time the email was received. To view all recipients, click 'View Details'" :
                                                            `The details below reflect only the ${UrlId !== undefined && UrlId !== null && UrlId[0] === "?LEAD" ? "lead" :
                                                                UrlId !== undefined && UrlId !== null && UrlId[0] === "?ACCOUNT" ? "contact" :
                                                                    UrlId !== undefined && UrlId !== null && UrlId[0] === "?DEAL" ? 'contact' :
                                                                        UrlId !== undefined && UrlId !== null && UrlId[0] === "?CONTACT" ? 'contact' : ''} owner at the time the email was received. To view all recipients, click 'View Details'`}
                                                /> : ""} */}
                                                                </Text>
                                                                <br />
                                                                {item.ToData?.length > 0 ? (
                                                                    <>
                                                                        {(expandedItems[index] ? item.ToData : item.ToData.slice(0, 3)).map((attendee, i) => (
                                                                            <div className='div-ellipsis' key={i} title={attendee.name?.trim() || attendee.email}>
                                                                                {attendee.name?.trim() || attendee.email}
                                                                            </div>
                                                                        ))}

                                                                        {item.ToData.length > 3 && !expandedItems[index] && (
                                                                            <span
                                                                                role="button"
                                                                                tabIndex={0}
                                                                                style={{ color: "#1890ff", cursor: "pointer" }}
                                                                                onClick={() => toggleExpand(index)}
                                                                                onKeyDown={(e) => {
                                                                                    if (e.key === "Enter" || e.key === " ") {
                                                                                        toggleExpand(index);
                                                                                    }
                                                                                }}
                                                                            >
                                                                                ...more
                                                                            </span>
                                                                        )}

                                                                        {item.ToData.length > 3 && expandedItems[index] && (
                                                                            <span
                                                                                role="button"
                                                                                tabIndex={0}
                                                                                style={{ color: "#1890ff", cursor: "pointer" }}
                                                                                onClick={() => toggleExpand(index)}
                                                                                onKeyDown={(e) => {
                                                                                    if (e.key === "Enter" || e.key === " ") {
                                                                                        toggleExpand(index);
                                                                                    }
                                                                                }}
                                                                            >
                                                                                show less
                                                                            </span>
                                                                        )}
                                                                    </>
                                                                ) : "Not Available"}
                                                            </Col>
                                                        </Row>
                                                    </Panel>
                                                </Collapse>
                                            </Card>
                                        </div>
                                    )
                                })}
                                <div style={{ textAlign: "center", marginBottom: 10 }}>
                                    <Pagination
                                        current={tablePage}
                                        pageSize={PAGE_SIZE}
                                        total={allMails.length}
                                        onChange={handleTableChange}
                                        showSizeChanger={false}
                                        showTotal={(total, range) => `${range[0]}-${range[1]} of ${totalCount.length} items`}
                                        itemRender={(page, type, originalElement) => {
                                            if (type === 'prev') {
                                                const isDisabled = tablePage <= 1;
                                                return (
                                                    <span role="button"
                                                        tabIndex={0}
                                                        className={`customeTable-pagianion ${isDisabled ? 'disabled' : ''}`}
                                                        style={{
                                                            cursor: isDisabled ? 'not-allowed' : 'pointer',
                                                            opacity: isDisabled ? 0.4 : 1,
                                                            display: 'inline-flex',
                                                            alignItems: 'center'
                                                        }}
                                                        onKeyDown={(event) => {
                                                            if ((event.key === 'Enter' || event.key === ' ') && !isDisabled) {
                                                                if (!isDisabled) handleTableChange2(tablePage - 1, "prev")
                                                            }
                                                        }}
                                                        onClick={(e) => {
                                                            if (!isDisabled) handleTableChange2(tablePage - 1, "prev");
                                                            e.stopPropagation();
                                                        }}
                                                    >
                                                        <FeatherIcon icon="chevron-left" size={16} style={{ marginTop: 5 }} />
                                                    </span>
                                                );
                                            }

                                            if (type === 'next') {
                                                const isDisabled = (tablePage * PAGE_SIZE) >= totalCount.length || isClickingRef.current;
                                                return (
                                                    <span role="button"
                                                        tabIndex={0}
                                                        className={`customeTable-pagianion ${isDisabled ? 'disabled' : ''}`}
                                                        style={{
                                                            cursor: isDisabled ? 'not-allowed' : 'pointer',
                                                            opacity: isDisabled ? 0.4 : 1,
                                                            display: 'inline-flex',
                                                            alignItems: 'center'
                                                        }}
                                                        onKeyDown={(event) => {
                                                            if ((event.key === 'Enter' || event.key === ' ') && !isDisabled) {
                                                                if (!isDisabled) handleTableChange2(tablePage + 1, "next")
                                                            }
                                                        }}
                                                        onClick={(e) => {
                                                            if (!isDisabled) handleTableChange2(tablePage + 1, "next");
                                                            e.stopPropagation();
                                                        }}
                                                    >
                                                        <FeatherIcon icon="chevron-right" size={16} style={{ marginTop: 5 }} />
                                                    </span>
                                                );
                                            }

                                            return originalElement; // normal page numbers
                                        }}
                                    />
                                </div>
                            </div>
                        </>
                        :
                        <div style={{ padding: "10%" }}>
                            <Empty />
                        </div>}
                </>
            }
            <Drawer
                className='Drawer-Header-Pages mail-detail-drawer'
                bodyStyle={{ padding: 0 }}
                closable={false}
                placement="right"
                title="Email Message"
                open={emailPopup}
                extra={
                    < Space >
                        <div className='Hover-Refresh2 back-hover1 able-style'
                            role="button"
                            tabIndex={0} title='Close'
                            onClick={() => emailClose()}
                            onKeyDown={(event) => {
                                if (event.key === 'Enter' || event.key === ' ') {
                                    emailClose()
                                }
                            }}
                            aria-label='Close'
                        > <CancelIcon width={24} height={24} /></div>
                    </Space >
                }
                width={window.innerWidth <= 768 ? "100%" : "70%"}>
                <MailDetailView detailsId={emailOpenId} detailsPage={popupType} Comefrom="Entity" setNaCTrigger={setNaCTrigger} />
            </Drawer>
            {emailUnlink && <Modal
                title="Unlink Confirmation"
                open={emailUnlink}
                onCancel={emailCloseUnlink}
                footer={[<div >
                    <Button htmlType="submit" size="small" className="gray-button" onClick={() => emailCloseUnlink()}>
                        <FeatherIcon icon="x" /> No
                    </Button>
                    <Button htmlType="submit" size="small" onClick={() => GetCallback(emailActivityId)} className='button_colors'>
                        <FeatherIcon icon="check" /> Yes
                    </Button>
                </div>
                ]}
            >
                Are you sure you want to unlink this email?
            </Modal>
            }
        </>
    );
}
EmailTable.propTypes = {
    UrlId: PropTypes.array.isRequired,
    NacTrigger: PropTypes.string.isRequired,
    setNaCTrigger: PropTypes.func.isRequired,
    profile: PropTypes.object.isRequired,
    emailactiontype: PropTypes.object.isRequired,
    refreshTrigger: PropTypes.string.isRequired,
    tabKey: PropTypes.string.isRequired,
};
export default React.memo(EmailTable)